import $ from 'jquery'

export const timingFunctionExpand = (t) => {
  return --t * t * t * t * t + 1;
};

export const timingFunctionCollapse = (t) => {
  if ((t *= 2) < 1) {
    return 0.5 * t * t * t * t * t;
  }

  return 0.5 * ((t -= 2) * t * t * t * t + 2);
};

export const animateImgKeyframe1 = (elRect, lastRect, isReverse) => {
  let lastTop = !isReverse ? (lastRect.top - document.documentElement.scrollTop) : lastRect.top
  let firsTop = !isReverse ? elRect.top : (elRect.top - document.documentElement.scrollTop)
  let str =  `
  translateX(${(lastRect.left - elRect.left + 101)}px)
  translateY(${(lastRect.top - elRect.top) + 134}px)
  scaleX(${lastRect.width / elRect.width})
  scaleY(${lastRect.height / elRect.height})
  `
  // debugger
  return str
}

export const animateImgKeyframe2 = `
  translateX(0)
  translateY(0)
  scale(1)
`
export const animateImgOptions= {
  duration: 1000,
  easing: 'cubic-bezier(0.2, 0, 0.2, 1)',
}

export const isInViewport = (el) => {
  var elementTop = $(el).offset().top;
  var elementBottom = elementTop + $(el).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementTop >= viewportTop && elementBottom <= viewportBottom;
}

export const isMobile = () => (
  window.innerWidth <= 991 || /Edge/.test(navigator.userAgent)
)


// WEBPACK FOOTER //
// ./src/animations.js